/**
 * Users section wrapper.
 *
 * Routing:
 *   /users                          → Reports listing (if no query params)
 *   /users?preset=today&platform=.. → Standalone builder (deep link)
 *   /users/new                      → New user query builder
 *   /users/reports/:id              → Saved report builder
 */
import { SectionPage } from '@/components/layout/SectionPage';
import { UsersBuilder } from './UsersBuilder';

export function UsersPage() {
  return (
    <SectionPage
      basePath="/users"
      BuilderComponent={UsersBuilder}
      queryParamKeys={['preset', 'start', 'platform', 'trafficSource']}
    />
  );
}
